import React from 'react'

const ContentLoader = () => {
  return (
    <div className="SB-gameCategory-section SB-liveCasino SB-contentLoader">
    <div className="SB-casinoCategoryItem">
      <div className="SB-casinoCategoryItem-header">
        <div className="SB-casinoCategoryItem-title"></div>
        <a className="SB-viewAll" href="index.html"></a>
      </div>
      <div className="SB-contentLoader SB-casinoGamesList">
        <div>
          <ul>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
            <li>
              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                <div className="SB-casinoGameItem-container"></div>
                <div className="SB-casinoGameItem-footer">
                  <div className="SB-casinoGameTitle"></div>
                  <div className="SB-casinoGameSubTitle"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ContentLoader
